/**
 * Configures Angular Material
 *
 * @type {ngConfig}
 * @see https://material.angularjs.org/latest/
 */
function tmrNgMaterialConfig(
  $mdAriaProvider,
  $mdCompilerProvider,
  $mdThemingProvider,
  $mdIconProvider,
  $mdInkRippleProvider
) {
  'ngInject'
  // Disable ARIA warnings.
  // ngAria is required by ngMaterial but we don't use it.
  $mdAriaProvider.disableWarnings()

  // Register custom palettes.

  // Primary palette.
  $mdThemingProvider.definePalette(
    'temeraLime',
    $mdThemingProvider.extendPalette('lime', {
      500: 'cdff00',
      600: 'c0eb00',
    })
  )

  // Accent and background palette.
  $mdThemingProvider.definePalette(
    'temeraGrey',
    $mdThemingProvider.extendPalette('grey', {
      50: 'FFFFFF',
      700: '525252',
      A700: '525252',
      A400: '3F3F3F',
      // Use opaque white for accent and backgrounds instead of .87 default opacity.
      contrastStrongLightColors: ['A100', 'A200', 'A400', 'A700'],
    })
  )

  // Success palettes.
  $mdThemingProvider.definePalette('temera-green', {
    50: 'eff5e2',
    100: 'd8e7b7',
    200: 'bed787',
    300: 'a4c756',
    400: '91bb32',
    500: '7daf0e',
    600: '75a80c',
    700: '6a9f0a',
    800: '609608',
    900: '4d8604',
    A100: 'd9ffb3',
    A200: 'c0ff80',
    A400: 'a7ff4d',
    A700: '9bff33',
    contrastDefaultColor: 'light',
    contrastDarkColors: [
      '50',
      '100',
      '200',
      '300',
      '400',
      '500',
      '600',
      'A100',
      'A200',
      'A400',
      'A700',
    ],
    contrastLightColors: ['700', '800', '900'],
  })

  // Red palette. Used for bad errors instead of warn.
  $mdThemingProvider.definePalette(
    'temera-red',
    $mdThemingProvider.extendPalette('red', {
      500: 'eb212e',
    })
  )

  // Configure default theme.
  let theme = $mdThemingProvider.theme('default')

  theme
    .primaryPalette('temeraLime')
    .accentPalette('temeraGrey')
    .warnPalette('deep-orange')
    .backgroundPalette('temeraGrey')
  theme.foregroundPalette[1] = 'rgb(0, 0, 0)' // Black text
  theme.foregroundPalette[2] = 'rgb(0, 0, 0)' // Black icons

  // $mdThemingProvider.theme('dark-temera').backgroundPalette('temeraGrey').dark();

  // Icons.
  $mdIconProvider.defaultFontSet('tmr-icon')

  // Disable ripple.
  $mdInkRippleProvider.disableInkRipple()

  // Allows sub-classing controllers of dialogs, modals, etc.
  $mdCompilerProvider.respectPreAssignBindingsEnabled(true)
}

export { tmrNgMaterialConfig as config }
